import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function UnaffectedEndometrialCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Unaffected individual with a family history of two first degree relatives with endometrial cancer under 60 years</>)
        ],
        properties: {
            color: 'teal'
        }
    });
}

export default UnaffectedEndometrialCancer;
